module.exports = function ({ linkType, linkName }) {
    return {
        event: 'BWSlinkClick',
        eventContext: { linkType, linkName }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/checkout/components/delivery/atmmapper/rsa-interactions-mapper.js
 **/